<template>
  <b-modal
    no-close-on-backdrop
    size="md"
    hide-footer
    id="view_category"
    title="EDITAR CATEGORIA"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name" />
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn :disabled="loading" type="submit" class="btn-save ml-2">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import toast from "../../../../lib/ToastNotification";
import api from "../../../../services/api";
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../../../Components/WarningRequiredFields.vue";

export default {
  name: "ViewCategory",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },

  props: {
    category: [Object, null],
  },

  data() {
    return {
      errors: [],
      loading: false,
      name: "",
    };
  },

  watch: {
    category() {
      if (this.category) this.$bvModal.show("view_category");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = this.category.name;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          id: this.category.id,
          name: this.name,
        };
        const response = await api.patch(
          "/rest-home/stock/items/category",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_category");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>